// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-tabs-__TabVideo-module___container"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tabs/TabVideo.module.css
// module id = 450
// module chunks = 0